import React from 'react';
import { ModalFooter } from '#app/components/ModalForm/components/styles';
import {
  ComposableModal,
  type ComposableModalProps,
} from '#app/components/ModalForm/ComposableModal';

export type ModalFormProps = Omit<
  ComposableModalProps,
  'show' | 'title' | 'onClose' | 'onSubmit' | 'children'
> & {
  /** Заголовок модалки (передаётся в ComposableModal как title) */
  header?: string;
  /** Открыта ли модалка (передаётся в ComposableModal как show) */
  modalVisible: boolean;
  /** Обработчик закрытия (передаётся в ComposableModal как onClose), также вызывается по Escape */
  closeForm: () => void;
  /** Опционально: по Enter вызывается этот колбэк (например, отправка формы) */
  submitForm?: () => void;
  width?: string;
  height?: string;
  children: React.ReactNode;
};

const ModalForm: React.FC<ModalFormProps> = ({
  modalVisible,
  closeForm,
  submitForm,
  children,
  header = '',
  width = 'auto',
  height,
  style,
  ...rest
}) => (
  <ComposableModal
    {...rest}
    show={modalVisible}
    title={header}
    onClose={closeForm}
    onSubmit={submitForm}
    style={{
      minWidth: width,
      maxWidth: width,
      ...(height && { height, maxHeight: height }),
      ...style,
    }}
  >
    <ModalFooter>{children}</ModalFooter>
  </ComposableModal>
);

export default ModalForm;
